module.exports = __webpack_public_path__ + "static/ir-ed3de0f543ffa76ecf33697a680c5dbd.svg";